import { ChangeDetectorRef, Component, HostBinding, Input, OnInit, ViewChild, NgZone } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { AppServiceService } from 'src/app/api/app-service.service';
import { PizzaIndicatorComponent } from 'src/app/component/pizza-indicator/pizza-indicator.component';


import { CartPage } from '../../cart/cart.page';

@Component({
  selector: 'app-toppingswizzard',
  templateUrl: './toppingswizzard.component.html',
  styleUrls: ['./toppingswizzard.component.scss'],
})
export class ToppingswizzardComponent implements OnInit {

  @Input() isFromCrossSelling: boolean;

  @ViewChild('slides', { static: false }) slides: IonSlides;
  @ViewChild(PizzaIndicatorComponent) indicatorComponent: PizzaIndicatorComponent;

  public quantity:number = 1;

  slideOpts = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 1, 
    allowTouchMove: false,
    autoplay: false,   
    autoHeight: true,
  };

  public current_slide_number = 0;
  public all_slides_count = 10;

  public currentSlideScenario:any = null;

  public selectedHalflingType:any = 'full';
  public pieces:number = 0;

  autoSelected: any = [];
  @HostBinding('style.--radio-color')
  public radioColor: any = (this.appService.appObject?.theme[this.appService.themeConfigFor]?.primaryColor ? this.appService.appObject?.theme[this.appService.themeConfigFor]?.primaryColor : '') + ' !important;';

  constructor(public modalController: ModalController, public appService: AppServiceService, private cdRef: ChangeDetectorRef,public zone: NgZone) {
    // console.log(this.appService.selectedDish);
    this.appService.appObject.errors = [];
    this.appService.hideCartButton = true;

    if(!this.appService.selectedDish.is_editing && this.appService.selectedDish.fullDishInfo.is_size == 'true'){
        this.appService.setSelectedSize(0);
    }
    if(this.appService.selectedDish.is_editing){
      this.selectedHalflingType = this.appService.selectedDish.half_side;
      if(this.appService.selectedDish.size_id){
        const s_index = this.appService.selectedDish.fullDishInfo.sizes.findIndex(size => size.id === this.appService.selectedDish.size_id);
        this.appService.setSelectedSize(s_index, false);
      }
      this.appService.calcSelectedDishTotal();
    }
  }

  async setSelectedSize($event){
    await this.appService.setSelectedSize($event);
    try {
    const count = this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenarios.filter(scenario => scenario.status === 'true').length; 
    this.all_slides_count = count;
    } catch (error) {
      console.log('error on select a size finding slides count:',error);
    }
  }

  selectHalflingType(type){
    let ctype = '';
    if(type == 'full_ha'){
      ctype = 'full';
    }
    if(type == 'hh_ha'){
      ctype = 'hh';
    }
    if(type == '4q_ha'){
      ctype = '4q';
    }

    if(ctype != this.selectedHalflingType){
      this.appService.selectedDish.selectedTopings = [];
    }
    
    this.zone.run(() => {
    if(this.appService.selectedDish.fullDishInfo.is_size == 'true'){
      if(type == 'hh_ha'){
        this.selectedHalflingType = 'hh';
        this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenarios = JSON.parse(JSON.stringify(this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenariosHH));
        this.pieces = 2;
      }else if(type == '4q_ha'){
        this.selectedHalflingType = '4q';
        this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenarios = JSON.parse(JSON.stringify(this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenarios4Q));
        this.pieces = 4;
      }else{
        this.selectedHalflingType = 'full';
        this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenarios = JSON.parse(JSON.stringify(this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenariosOriginal));
        
        this.pieces = 0;
      }
    } else{
      if(type == 'hh_ha'){
        this.selectedHalflingType = 'hh';
        this.appService.selectedDish.fullDishInfo.scenarios = JSON.parse(JSON.stringify(this.appService.selectedDish.fullDishInfo.scenariosHH));
        this.pieces = 2;
      }else if(type == '4q_ha'){
        this.selectedHalflingType = '4q';
        this.appService.selectedDish.fullDishInfo.scenarios = JSON.parse(JSON.stringify(this.appService.selectedDish.fullDishInfo.scenarios4Q));
        this.pieces = 4;
      }else{
        this.selectedHalflingType = 'full';
        this.appService.selectedDish.fullDishInfo.scenarios = JSON.parse(JSON.stringify(this.appService.selectedDish.fullDishInfo.scenariosOriginal));
        
        this.pieces = 0;
      }
    } 
    console.log('this.appService.selectedDish:',this.appService.selectedDish);
    // store the selected halfing tyoe on selected dish for future validations
    this.appService.selectedDish.half_side = this.selectedHalflingType;
    this.slides.slideNext();
  });
  }

  wizzardNext(){
    this.appService.validateDishSenarioToppingConfigsRealTimeWizard(this.currentSlideScenario);
    // return;
    // validate current slide topping scenario errors
    // console.log('currentSlideScenario:',this.currentSlideScenario);
    // console.log('appService?.appObject?.errors1:',this.appService?.appObject?.errors);

    if(this.currentSlideScenario?.is_half){
      return false;
    }

    if(!this.appService.toppingWizardNextButtonValidation(this.currentSlideScenario)){
      return;
    }
    this.slides.slideNext();

  }
  wizzardBack(){

    this.slides.slidePrev();

  }


  public slide_errors = [];

  show_e(){
    console.log(this.slide_errors);
  }

  add_error_to_slide(){

  }

  async getSlideCount() {
 //   const count = await this.slides.length();
 //   console.log('Total number of slides:', count);
    return this.current_slide_number;
  }

  async updateCurrentSlide() {
    const index = await this.slides.getActiveIndex();
    const count = await this.slides.length();
    this.all_slides_count = count - 1;
    this.current_slide_number = index;
    this.show_e();
    let activeScenario;
    // get current slide topping scenario by slide index (if selected dish has sizes, then remove 1 from the index coz first slide is for sizes)
    if(this.appService.selectedDish.fullDishInfo.is_size == 'true'){
      activeScenario = this.getActiveScenarios(this.appService.selectedDish.fullDishInfo.sizes[this.appService.selectedDish.size_index].scenarios);
    }else{
      activeScenario = this.getActiveScenarios(this.appService.selectedDish.fullDishInfo.scenarios);
    }
    this.currentSlideScenario = activeScenario[this.appService.selectedDish.fullDishInfo.is_size != 'true' ? index : (index-1)];

     if(this.currentSlideScenario.half_side && this.pieces != 0){
        switch (this.currentSlideScenario.half_side) {
          case '1_q':
              this.indicatorComponent.to_0();
            break;
            case '2_q':
              this.indicatorComponent.to1_4();
            break;
            case '3_q':
              this.indicatorComponent.to1_2();
            break;
            case '4_q':
              this.indicatorComponent.to3_4();
            break;
            case 'left_q':
              this.indicatorComponent.to_0();
            break; 
            case 'right_q':
              this.indicatorComponent.to1_2();
            break; 
            case 'full':
              this.indicatorComponent.to_full_active();
            break;
            default:
              this.indicatorComponent.to_1();
            break;
        }
     }
  }

  calculateWidth(num1: number, num2: number): number {
    num1 = num1;
    num2 = num2 - 1;
    if (num2 === 0) {
      return 0;  // Avoid division by zero
    }
    return (num1 / num2) * 100;
  }


  tempClog(obj){
    console.log('errors');
    console.log(obj)
  }


  ngOnInit() {
    // select first scenario as default if dish has no sizes, if there is sizes the first slide will be sizes
    if(this.appService.selectedDish && this.appService.selectedDish.fullDishInfo && this.appService.selectedDish.fullDishInfo.is_size != 'true'){
      let activeScenario = this.getActiveScenarios(this.appService.selectedDish.fullDishInfo.scenarios)
      if(activeScenario && activeScenario[0]) this.currentSlideScenario = activeScenario[0];
    }
  }

  ngDoCheck() {
    this.radioColor = this.appService.appObject.theme[this.appService.themeConfigFor]?.primaryColor || '';
  }

  // solution for ngCheckedAfterExpressionChanged exception, check it again 
  ngAfterViewInit(): void {
    this.cdRef.detectChanges();

    setTimeout(async()=>{
      const count = await this.slides.length();
      this.all_slides_count = count - 1;
    },500);
  }

  async dismiss() {
    // console.log(this.appService.hideCartButton);
    this.modalController.dismiss({
      'dismissed': true
    });

    if (this.appService.cartIsOpen) {
      const modal = await this.modalController.create({
        component: CartPage,
        cssClass: 'custom-popup'
      });
      await modal.present();
    } else {
      this.appService.hideCartButton = false;
    }
  }

  /**
   * Will return only active scenarios
   * @param scenarioList scenario list to filter from 
   * @returns filtered scenario list
   */
  getActiveScenarios(scenarioList) {
    if (scenarioList && scenarioList.length) {
      let activeScenarios = scenarioList.filter((scenario) => scenario.status === 'true');
      return activeScenarios;
      //return activeScenarios.sort((a,b) => a.position - b.position);
    } else {
      return [];
    }
  }

  /**
   * Will return status active topping list
   * @param toppingList topping list to filter from
   * @returns filtered topping list that status is active
   */
  getActiveToppings(toppingList) {
    if (toppingList && toppingList.length) {
      return toppingList.filter((topping) => {
        return topping.status === 'true'
      });
    } else {
      return [];
    }
  }

  autoSelect(topings, index, fun) {
    switch (fun) {
      case 'selectTopingOp':
        this.appService.selectTopingOp(null, index);
        break;

      default:
        break;
    }
    // console.log('auto', topings[0]['id']);
    return topings[0]['id'];
  }

  addFirstToping(id, index) {

    var ex = this.autoSelected.indexOf(id);
    if (ex == -1) {
      this.autoSelected.push(id);
      // console.log(id, index);
      this.appService.selectTopingOp2({ detail: { value: id } }, index);
    }

  }

  addSizeToCart(isFromCrossSelling, isWizard, currentSlideScenario){
  
    this.appService.validateDishSenarioToppingConfigsRealTimeWizard(this.currentSlideScenario);
  
    if(this.appService.toppingWizardNextButtonValidation(this.currentSlideScenario) && this.pieces != 0){
      this.indicatorComponent.to_full_active();
    }


    setTimeout(() => {
      this.appService.addSizeToCart(isFromCrossSelling, isWizard, currentSlideScenario,this.quantity);
    }, 500);
 
  }

  isSelectedType(t){
    let type = '';
    if(t == 'full_ha'){
      type = 'full';
    }

    if(t == 'hh_ha'){
      type = 'hh';
    }

    if(t == '4q_ha'){
      type = '4q';
    }
    
    if(type == this.selectedHalflingType){
        return true;
    }

    return false;
  }

  /**
   * Will update dish qty
   * @param operation + or -
   */
  updateQty(operation:'+'|'-'){
    if(operation === '+'){
      this.quantity++;
    }else if(this.quantity > 1){
      this.quantity--;
    }
  }

}